import { Chip } from "@mui/material";

interface Props {
  size: "small" | "medium";
  color:
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
}

export function SupplierShipmentChip(props: Props) {
  const { size, color } = props;

  return (
    <Chip
      label="Supplier Shipment"
      size={size}
      color={color}
      variant="outlined"
    />
  );
}
